import apiClient from 'api/config/apiClient'

export default {
  getInvoiceExtract(payload) {
    return apiClient.request('cache-disable/invoice_extract', payload)
  },
}